import React, { useState, useRef, useEffect } from "react";
import GoogleButton from "../components/GoogleAuth";
import "./createLegalDoc.css";
import LeftPanel from "../components/leftPanel";
import { logEvent } from "firebase/analytics";
import { config } from "../config";
import { analytics } from "../components/firebase";
import { useLocation, useNavigate } from "react-router-dom";
import FullScreenLoader from "../components/FullScreenLoader";
import { toast, ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet-async";
const CaseAnalyser = () => {
  const [legalCaseDetails, setLegalCaseDetails] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const googleAuthRef = useRef(null);
  const textAreaRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
    const initialText = location.state?.text || "";
    setLegalCaseDetails(initialText);
  }, [location.state]);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleLoginSuccess = () => {
    toast.success("Logged in – go ahead and click Analyse again!");
  };

  const handleLoginFailure = () => {
    toast.error("Login failed. Please try again.");
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 3 * 1024 * 1024) {
        toast.error("File size must be less than 3MB.");
        return;
      }
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      if (["pdf", "docx"].includes(fileExtension)) {
        setFile(selectedFile);
      } else {
        toast.error("Unsupported file type.");
      }
    }
  };

  const handleGenerate = async () => {
    setErrors({});
    let hasError = false;

    logEvent(analytics, "Analyse Button click legal", {
      button_name: "Analyse_button_case",
    });

    if (!legalCaseDetails) {
      setErrors((prev) => ({
        ...prev,
        legalCaseDetails: "Please enter case details.",
      }));
      hasError = true;
      textAreaRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setTimeout(() => {
        setErrors((prev) => {
          const updated = { ...prev };
          delete updated.legalCaseDetails;
          return updated;
        });
      }, 5000);
    }
    if (hasError) return;

    setIsLoading(true);
    document.body.classList.add("no-scroll");

    try {
      const formData = new FormData();
      formData.append("legalCaseDetails", legalCaseDetails);
      if (file) {
        formData.append("pdf_file", file);
      }

      for (let [key, value] of formData.entries()) {
      }

      const response = await fetch(`${config.baseURL}/Summarizer_gen.php`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const data = await response.json();

      if (data.error) {
        if (data.error === "Authentication failed") {
          googleAuthRef.current?.login();
          return;
        }
        if (data.redirect === "premium") {
          navigate(`/premium?id=${data.premiumId}`);
          return;
        }
        toast.error("Please re-try after some time");
        return;
      }

      if (data.success && data.resultText) {
        navigate("/result", { state: { result: data.resultText } });
        setLegalCaseDetails("");
        setFile(null);
      } else {
        toast.error("Please re-try after some time");
      }
    } catch (error) {
      toast.error("Please re-try after some time");
      logEvent(analytics, "error", {
        error_type: "anlyzer api failed legal",
        error_message: error.message,
        action: "analyse_button_click",
      });
    } finally {
      setIsLoading(false);
      document.body.classList.remove("no-scroll");
    }
  };

  return (
    <>
    <Helmet key="case-analyzer">
  <title>AI Case Analyzer | Analyze Legal Cases Instantly with AI</title>

  <meta
    name="description"
    content="Use our AI Case Analyzer to review, summarize, and understand legal case details from text or uploaded documents. Get quick, accurate, and professional legal case insights powered by artificial intelligence."
  />

  <meta
    name="keywords"
    content="AI legal case analyzer, case summarizer, legal document analysis, upload legal case PDF, analyze legal files online, case review AI tool, automated legal case reading, case law insights, AI-powered legal analysis, online case analyzer, AI legal assistant, smart legal research, document upload for analysis"
  />

  <link rel="canonical" href="https://legaldocumentgenerator.com/case-analyzer" />
</Helmet>
      <div className="create_background">
        {isLoading && <FullScreenLoader />}
        <LeftPanel />
        <div className="create_main">
          <div className="create_title">
            <img
              src={config.Backbutton}
              alt="back icon"
              onClick={handleBackClick}
            />
            Analyse the Case
          </div>
          <div className="create_inputbox1">
            Case Details
            <div className="textarea_wrapper">
              <textarea
                ref={textAreaRef}
                className={`textarea_input_analyzer ${
                  errors.legalCaseDetails ? "error" : ""
                }`}
                placeholder="Write here"
                value={legalCaseDetails}
                onChange={(e) => setLegalCaseDetails(e.target.value)}
                maxLength={3000}
              />
              {!file ? (
                <label className="custom_file_upload">
                  <img
                    src={config.uploadFile}
                    alt="Upload"
                    className="upload_icon"
                  />
                  Upload File
                  <input
                    type="file"
                    accept=".pdf, .docx"
                    onChange={handleFileChange}
                    className="hidden_file_input"
                  />
                </label>
              ) : (
                <div className="uploaded_file_box">
                  <img
                    src={config.uploadedDoc}
                    alt="File"
                    className="file_icon"
                  />
                  <span className="file_name">{file.name}</span>
                  <button
                    className="remove_file_btn"
                    onClick={() => setFile(null)}
                  >
                    ✖
                  </button>
                </div>
              )}
            </div>
            {errors.legalCaseDetails && (
              <div className="error-message">{errors.legalCaseDetails}</div>
            )}
          </div>
          <ToastContainer />
          <GoogleButton
            id="loginHidden"
            ref={googleAuthRef}
            onLoginSuccess={handleLoginSuccess}
            onLoginFailure={handleLoginFailure}
          />
          <button className="generate_btn" onClick={handleGenerate}>
            Analyse the case
          </button>
        </div>
      </div>
    </>
  );
};

export default CaseAnalyser;
